module.exports = "assets/fonts/Gotham-Book.woff2";